import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Badge,
    Card, CardBody, CardTitle,
    Col,
    Container,
    Progress,
    Row
} from 'reactstrap';
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../../components/display/Loader";

class SummaryModule extends Component {
    content = () => {
        const {application, tuVerified} = this.props;

        const percent_complete = application.application_percent_complete;
        const basic = application.is_basic_complete;
        const advanced = application.is_advanced_complete;
        const rental_history = application.rental_history_rentals;
        const rental_valid = PolyUtil.validArr(rental_history);
        const employment = application.employment_history_positions;
        const employment_valid = PolyUtil.validArr(employment);
        const vehicle = application.is_vehicle_complete;
        const bio = application.is_bio_complete;

        return (
            <div>
                <Card style={{marginTop: '2em', marginBottom: '2em', textAlign: 'center'}} color={percent_complete === 100 ? 'success' : 'primary'} outline>
                    <CardBody>
                        <Progress bar color={percent_complete === 100 ? 'success' : 'primary'} value={percent_complete}/>
                        <CardTitle style={{marginTop: '1em'}}>Summary: {percent_complete}% Complete</CardTitle>
                        <Container style={{textAlign: 'left'}}>
                            <SummaryModuleRow complete={basic} title="Basic Info"/>
                            <SummaryModuleRow complete={advanced} title="General Info"/>
                            <SummaryModuleRow complete={rental_valid} title="Rental History"/>
                            <SummaryModuleRow complete={employment_valid} title="Employment History"/>
                            <SummaryModuleRow complete={vehicle} title="Vehicle Info"/>
                            <SummaryModuleRow complete={bio} title="Bio"/>
                            <SummaryModuleRow complete={tuVerified} title="Credit" message="Verified by TransUnion" incompleteMessage="Unconfirmed"/>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        );
    };

    render() {
        return PolyUtil.polyRender(this.props, ['application'], this.content, (<Loader spin isLoading/>));
    }
}

class SummaryModuleRow extends Component {
    render() {
        const {complete, title} = this.props;
        const message = this.props.message || 'Complete';
        const incMessage = this.props.incompleteMessage || 'Incomplete';
        return (
            <Row>
                <Col style={{textAlign: 'right'}} sm={3}><h5>{title}:</h5></Col>
                <Col sm={9}><Badge color={complete ? 'success' : 'warning'}>{complete ? message : incMessage}</Badge></Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        application: state.tenant.application,
        tuVerified: state.tenant.idmaStatus === 'Verified'
    };
};

export default connect(mapStateToProps)(SummaryModule);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/SummaryModule.js